import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'open_with_faire-owf_application_cta-click';

/**
 * Track on click of the OwF application CTA from various Faire Academy sources
 */
export function trackOpenWithFaireOwfApplicationCtaClick(
  User_State_string: string,
  Source_string2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { User_State_string, Source_string2 },
  });
}
